import { Box, CircularProgress, Portal } from "@mui/material";
import { sessionEffectivenessRuleService } from "Apis";
import ConditionGroupProvider from "Components/ConditionalGroup/ConditionGroupProvider";
import EffectivenessForm from "features/effectiveness/components/EffectivenessForm";
import { TypographyHelp } from "Components/UI/TypographyHelp";
import { useSelectedProject } from "Hooks";
import { TEffectivenessRule } from "Interfaces";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { useMount } from "react-use";

function SessionEffectivenessRulesPage() {
  const { selectedProject } = useSelectedProject();
  const { ruleId } = useParams<{ ruleId: string }>();
  const [title, setTitle] = useState("");
  const [effectivenessRule, setEffectivenessRule] = useState<
    TEffectivenessRule | undefined
  >(undefined);

  useMount(() => {
    if (!ruleId) {
      return;
    }
    if (ruleId === "new") {
      setEffectivenessRule({});
      setTitle("New Session Effectiveness Rule");
      return;
    }
    const load = async () => {
      const res =
        await sessionEffectivenessRuleService.sessionEffectivenessRuleServiceReadRule(
          {
            projectId: selectedProject?.id as number,
            ruleId: Number(ruleId),
          }
        );
      setEffectivenessRule(res);
      setTitle(res.name || "");
    };
    load();
  });

  if (!selectedProject || !effectivenessRule) {
    return <CircularProgress />;
  }

  return (
    <Box pt={5}>
      <Portal container={() => document.getElementById("pageTitle")}>
        <TypographyHelp
          variant="h1"
          text={title}
          placement={"right"}
          tooltip={
            "Configure the rules which will define if a session was successful / effective"
          }
        />
      </Portal>
      <ConditionGroupProvider>
        <EffectivenessForm
          rule={effectivenessRule}
          setRule={setEffectivenessRule}
          project={selectedProject}
          isPageview={false}
        />
      </ConditionGroupProvider>
    </Box>
  );
}

export default SessionEffectivenessRulesPage;
